import React, { useContext } from 'react';
import { Container, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import OperationContext from '../../context';
import { PageHeader, Section } from '../../../../../shared/components';
import SupervisionReportContext from './context';
import NotificationContext from '../../../../Notifications/NotificationContext';
import operSupervisionReportService from '../../../../../services/operSupervisionReportService';
import FlowMain from '../FlowMain';
import FlowStart from '../FlowStart';
import useQuery from '../../../../../shared/hooks/useQuery';
import PerformanceBadge from '../../../PerformanceBadge';
import FlowTitleWarning from '../FlowTitleWarning';
import FlowParentTitleWarning from '../FlowParentTitleWarning';

const SupervisionReport: React.FC = () => {
  const { t } = useTranslation();
  const { operation } = useContext(OperationContext);
  const { data, loader, reload } = useContext(SupervisionReportContext);
  const { reload: reloadNotifications } = useContext(NotificationContext);

  const queryParams = useQuery();
  const from = queryParams.get('from') || undefined;

  const reloadWithNotifications = () => {
    reload();
    reloadNotifications();
  };

  const getContent = () => {
    if (!data) {
      return null;
    }
    return data.content ? (
      <FlowMain
        data={data}
        reload={reloadWithNotifications}
        operFlowService={operSupervisionReportService}
        flowType="SR"
        flowTypeName="Supervision Report"
      />
    ) : (
      <FlowStart
        hasToolkitEsrr={data.hasToolkitEsrr}
        hasIndicators={data.hasIndicators}
        loader={loader}
        reload={reloadWithNotifications}
        operFlowService={operSupervisionReportService}
        flowType="SR"
        flowTypeName="Supervision Report"
        languages={['en', 'es', 'fr', 'pt']}
        milestoneCreateConditionDate={data.milestoneCreateConditionDate}
      />
    );
  };

  return (
    <Container className="dashboard">
      <PageHeader
        title={t('titleSupervisionReport', { number: operation.number })}
        backUrl={from}
      />
      <Row>
        <Section
          title={
            data && data.content ? (
              <>
                <h5>{t('titleSectionSupervisionReport')}</h5>
                {operation.safeguardPerformance && (
                  <div className="d-flex ml-4 align-items-center">
                    <span className="mr-1">SPR:</span>
                    <PerformanceBadge code={operation.safeguardPerformance} />
                  </div>
                )}
              </>
            ) : (
              ''
            )
          }
          title2={
            data &&
            data.ownerOperation &&
            data.relatedOperations.length > 0 &&
            (data.ownerOperation.number !== operation.number ? (
              <FlowTitleWarning operationNumber={data.ownerOperation.number} />
            ) : (
              <FlowParentTitleWarning operations={data.relatedOperations} />
            ))
          }
        >
          {getContent()}
        </Section>
      </Row>
    </Container>
  );
};

export default SupervisionReport;
